import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  CardContent,
  Card,
  List,
  Button,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  Stack,
  Chip,
  Tooltip,
  CircularProgress,
  Alert,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FindReplaceIcon from "@mui/icons-material/FindReplace";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import MouseOutlinedIcon from "@mui/icons-material/MouseOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import { useNavigate } from "react-router-dom";
import {
  Group,
  Image as KonvaImage,
  Layer,
  Line,
  Rect,
  Stage,
} from "react-konva";
import { toast } from "react-toastify";
import FpCropEdit from "./FpCropEditor";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import CustomCircularP from "../../widgets/CustomCircularP";
import BackBtn from "../../widgets/BackBtn";
import { ADMIN, API_ENDPOINT } from "../../utils/constants";
import RdMyModal from "../../widgets/myModal/RdMyModal";
import { getHoverColor, hexToRGBA, toastError } from "../../utils/util";
import useApiEp from "../../hooks/useApiEp";
import { getHeader } from "../../utils/utils2";
const TRANSPARENCY = 0.8;
const HOVER_TRANSPARENCY = 0.68;
export function getImageDimen(imgWidth, imgHeight) {
  const width = Math.min(imgWidth, 1280);
  const height = width * (imgHeight / imgWidth);
  return { width, height };
}

export function getScales(containerWidth, imgWidth, imgHeight) {
  const scaleX =
    Math.min(imgWidth, containerWidth) /
    getImageDimen(imgWidth, imgHeight).width;
  const scaleY =
    (Math.min(imgWidth, containerWidth) * (imgHeight / imgWidth)) /
    getImageDimen(imgWidth, imgHeight).height;

  return { scaleX, scaleY };
}
function GeneralFloorPlan() {
  const [reloadFp, setReloadFp] = useState(false);
  const { data, isLoading, isError, error } = useApiEp(
    `/admin/get-floor?id=1&r=${reloadFp}`
  );
  const navigate = useNavigate();
  const [showImageCrop, setShowImageCrop] = useState(false);
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [image, setImage] = useState(null);
  const [gMenuEl, setGmenuEl] = useState(null);
  const [hMenuEl, setHmenuEl] = useState(null);
  const [stageScale, setStageScale] = useState(1);
  const [stagePos, setStagePos] = useState({ x: 0, y: 0 });
  const [newHalls, setNewHalls] = useState([]);
  const [showHallDelete, setShowHallDelete] = useState(false);
  const [showFloorDelete, setShowFloorDelete] = useState(false);
  const [targetHall, setTargetHall] = useState();
  const [hallDeleting, setHallDeleting] = useState(false);
  const [floorDeleting, setFloorDeleting] = useState(false);
  const [confirmAllDelete, setConfirmAllDelete] = useState(false);

  const handleWheel = (e) => {
    e.evt.preventDefault();

    const scaleBy = 1.08;
    const stage = e.target.getStage();
    const oldScale = stage.scaleX();

    const pointer = stage.getPointerPosition();

    // Calculate the new scale
    const newScale = e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;

    // Limit the scale
    const minScale = 0.5;
    const maxScale = 3;
    const finalScale = Math.max(minScale, Math.min(maxScale, newScale));

    setStageScale(finalScale);

    // Calculate the new position to keep the pointer position consistent
    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };

    const newPos = {
      x: pointer.x - mousePointTo.x * finalScale,
      y: pointer.y - mousePointTo.y * finalScale,
    };

    setStagePos(newPos);
  };

  useEffect(() => {
    if (data && !image) {
      const img = new window.Image();
      img.src = data.image;
      img.onload = () => {
        setImage({
          img: img,
          width: img.width,
          height: img.height,
        });
      };
    }
  }, [data, image]);

  useEffect(() => {
    if (data && image && containerRef) {
      const containerWidth = containerRef.current.offsetWidth;
      setDimensions({
        width: containerWidth,
        height: 560,
      });
      const scale = getScales(containerWidth, image.width, image.height);
      const scaleX = scale.scaleX;
      const scaleY = scale.scaleY;

      const halls = data.halls.map((hall) => {
        if (hall.shape.type === "Rectangle") {
          return {
            ...hall,
            shape: {
              ...hall.shape,
              shape: {
                ...hall.shape.shape,
                x: hall.shape.shape.x * scaleX,
                y: hall.shape.shape.y * scaleY,
                width: hall.shape.shape.width * scaleX,
                height: hall.shape.shape.height * scaleY,
              },
            },
          };
        } else if (hall.shape.type === "Polygon") {
          return {
            ...hall,
            shape: {
              ...hall.shape,
              shape: hall.shape.shape.map((point, index) =>
                index % 2 === 0 ? point * scaleX : point * scaleY
              ),
            },
          };
        }
        return hall;
      });
      setNewHalls(halls);
    }
  }, [data, image, containerRef]);

  const hanldeHallMenuClick = (e, hall) => {
    setTargetHall(hall);
    setHmenuEl(e.currentTarget);
  };

  const handleGeneralPlanEdit = (e) => {
    setGmenuEl(e.currentTarget);
  };

  const handleGmenuClick = (event, action) => {
    setGmenuEl(null); // Close the menu

    switch (action) {
      case "Edit Image":
        setShowImageCrop(true);
        break;

      case "Replace Image":
        setShowImageCrop(true);
        break;

      case "Delete Image":
        setShowFloorDelete(true);
        break;

      default:
        console.warn("Unknown action:", action);
        break;
    }
  };

  const handleHmenuClick = (e, m) => {
    setHmenuEl(null); // Close the menu
    switch (m) {
      case "Edit Hall":
        navigate(`/fp-add-hall?id=${targetHall._id}`);
        break;
      case "Delete Hall":
        setShowHallDelete(true);
        break;
      default:
        console.warn("Unknown action:", m);
        break;
    }
  };

  const handleHallDelete = async (id) => {
    setHallDeleting(true);
    try {
      const response = await axios.delete(
        `${API_ENDPOINT}/admin/delete-hall?id=${id}`,
        getHeader()
      );

      setReloadFp((prev) => !prev);
      toast.success(response.data.message);
    } catch (error) {
      toastError(error);
    } finally {
      setHallDeleting(false);
    }
  };

  const handleFloorDelete = async (id) => {
    setFloorDeleting(true);
    try {
      const { data } = await axios.delete(
        `${API_ENDPOINT}/user/delete-floor?id=${id}`,
        getHeader()
      );
      toast.success(data.message);
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } catch (error) {
      toastError(error);
    } finally {
      setFloorDeleting(false);
    }
  };

  const onYesHallDelete = () => {
    setShowHallDelete(false);
    handleHallDelete(targetHall._id);
  };

  const onYesFloorDelete = () => {
    setShowFloorDelete(false);
    handleFloorDelete(data?._id);
  };

  const onYesDeleteAllHalls = async () => {
    setHallDeleting(true);
    try {
      const response = await axios.delete(
        `${API_ENDPOINT}/user/delete-all-halls?id=${data?.eventId}`,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } catch (error) {
      toastError(error);
    } finally {
      setHallDeleting(false);
    }
    setConfirmAllDelete(false);
  };

  const hallCount = data?.halls?.length || 0;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1440px",
        mx: "auto",
        px: { xs: 2, sm: 3 },
        py: { xs: 2, sm: 3 },
      }}
    >
      <CustomCircularP show={isLoading || hallDeleting || floorDeleting} />
      <RdMyModal
        showModal={showImageCrop}
        setShowModal={setShowImageCrop}
        modalC={<FpCropEdit upload_type={"MAP_IMAGE"} />}
      />

      <SimpleYesNoDialog
        title="Please Confirm!"
        message={`Are you sure you want to delete all halls?`}
        onYes={onYesDeleteAllHalls}
        show={confirmAllDelete}
        setShow={setConfirmAllDelete}
      />
      <SimpleYesNoDialog
        title="Please Confirm!"
        message={`Are you sure you want to delete this Map?`}
        onYes={onYesFloorDelete}
        show={showFloorDelete}
        setShow={setShowFloorDelete}
      />
      <SimpleYesNoDialog
        title="Please Confirm!"
        message={`Are you sure you want to delete ${targetHall?.name}? Please be aware that all data related to this hall will be deleted.`}
        onYes={onYesHallDelete}
        show={showHallDelete}
        setShow={setShowHallDelete}
      />

      <Menu
        anchorEl={gMenuEl}
        open={Boolean(gMenuEl)}
        onClose={() => setGmenuEl(null)}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, minWidth: 190, borderRadius: 2 },
        }}
      >
        <MenuItem
          disabled={!image}
          onClick={(e) => handleGmenuClick(e, "Replace Image")}
        >
          <ListItemIcon>
            <FindReplaceIcon fontSize="small" />
          </ListItemIcon>
          Replace Image
        </MenuItem>
        <Divider />
        <MenuItem
          disabled={!image}
          sx={{ color: "error.main" }}
          onClick={(e) => handleGmenuClick(e, "Delete Image")}
        >
          <ListItemIcon>
            <DeleteOutlineIcon color="error" fontSize="small" />
          </ListItemIcon>
          Delete Image
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={hMenuEl}
        open={Boolean(hMenuEl)}
        onClose={() => setHmenuEl(null)}
        PaperProps={{
          elevation: 3,
          sx: { mt: 0.5, minWidth: 170, borderRadius: 2 },
        }}
      >
        <MenuItem onClick={(e) => handleHmenuClick(e, "Edit Hall")}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          Edit Hall
        </MenuItem>
        <Divider />
        <MenuItem
          sx={{ color: "error.main" }}
          onClick={(e) => handleHmenuClick(e, "Delete Hall")}
        >
          <ListItemIcon>
            <DeleteOutlineIcon color="error" fontSize="small" />
          </ListItemIcon>
          Delete Hall
        </MenuItem>
      </Menu>

      <Box sx={{ mb: 2 }}>
        <BackBtn />
      </Box>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 700, letterSpacing: "-0.02em" }}
          >
            Floor plan
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            Manage the venue map and the exhibition halls linked to it.
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: "wrap" }}>
          <Chip
            icon={<MapOutlinedIcon />}
            label={data?.image ? "Map uploaded" : "Map not uploaded"}
            color={data?.image ? "success" : "default"}
            variant="outlined"
            sx={{ fontWeight: 600, bgcolor: "background.paper" }}
          />
          <Chip
            icon={<MeetingRoomOutlinedIcon />}
            label={`${hallCount} ${hallCount === 1 ? "hall" : "halls"}`}
            variant="outlined"
            sx={{ fontWeight: 600, bgcolor: "background.paper" }}
          />
        </Stack>
      </Stack>

      {isError && (
        <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
          {error?.response?.data?.message ||
            "The floor plan could not be loaded. Please try again."}
        </Alert>
      )}

      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12} lg={8}>
          <Card
            variant="outlined"
            sx={{
              height: "100%",
              borderRadius: 3,
              borderColor: "divider",
              boxShadow: "0 10px 30px rgba(2, 71, 95, 0.06)",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: { xs: 2, sm: 3 }, pb: "24px !important" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  justifyContent: "space-between",
                  gap: 2,
                  mb: 2.5,
                }}
              >
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: 2,
                      display: "grid",
                      placeItems: "center",
                      color: "primary.main",
                      bgcolor: "rgba(2, 71, 95, 0.08)",
                    }}
                  >
                    <MapOutlinedIcon />
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight={700}>
                      General plan
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Select a highlighted hall to open its detailed plan.
                    </Typography>
                  </Box>
                </Stack>

                <Button
                  onClick={handleGeneralPlanEdit}
                  variant="outlined"
                  startIcon={<EditIcon />}
                  size="small"
                  sx={{
                    flexShrink: 0,
                    alignSelf: { xs: "flex-start", sm: "center" },
                    textTransform: "none",
                    borderRadius: 2,
                  }}
                >
                  Manage map
                </Button>
              </Box>
              {data?.image ? (
                <Box>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{
                      mb: 1.5,
                      color: "text.secondary",
                      flexWrap: "wrap",
                      rowGap: 1,
                    }}
                  >
                    <Stack direction="row" spacing={0.75} alignItems="center">
                      <MouseOutlinedIcon sx={{ fontSize: 18 }} />
                      <Typography variant="caption">Drag to pan</Typography>
                    </Stack>
                    <Stack direction="row" spacing={0.75} alignItems="center">
                      <ZoomInOutlinedIcon sx={{ fontSize: 18 }} />
                      <Typography variant="caption">Scroll to zoom</Typography>
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{ ml: { sm: "auto !important" }, fontWeight: 600 }}
                    >
                      {Math.round(stageScale * 100)}%
                    </Typography>
                  </Stack>
                  <Box
                    ref={containerRef}
                    sx={{
                      height: 560,
                      overflow: "hidden",
                      position: "relative",
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2.5,
                      bgcolor: "grey.50",
                      backgroundImage:
                        "linear-gradient(45deg, rgba(2,71,95,0.025) 25%, transparent 25%), linear-gradient(-45deg, rgba(2,71,95,0.025) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(2,71,95,0.025) 75%), linear-gradient(-45deg, transparent 75%, rgba(2,71,95,0.025) 75%)",
                      backgroundSize: "24px 24px",
                      backgroundPosition: "0 0, 0 12px, 12px -12px, -12px 0px",
                      "& canvas": { cursor: "grab" },
                      "& canvas:active": { cursor: "grabbing" },
                    }}
                  >
                    {image ? (
                      <Stage
                        width={dimensions.width}
                        height={dimensions.height}
                        scaleX={stageScale}
                        scaleY={stageScale}
                        x={stagePos.x}
                        y={stagePos.y}
                        draggable={true}
                        onWheel={handleWheel}
                      >
                        <Layer>
                          <KonvaImage
                            image={image.img}
                            width={Math.min(image.width, dimensions.width)}
                            height={
                              Math.min(image.width, dimensions.width) *
                              (image.height / image.width)
                            }
                            x={0}
                            y={0}
                          />
                          {newHalls
                            ?.filter((hall) => hall.shape.type === "Polygon")
                            .map((hall, index) => (
                              <Group key={index}>
                                <Line
                                  points={hall.shape.shape}
                                  fill={hexToRGBA(hall.color, TRANSPARENCY)}
                                  stroke={hexToRGBA(hall.color, TRANSPARENCY)}
                                  strokeWidth={hall.strokeWidth}
                                  closed={true}
                                  onClick={() => {
                                    navigate(`/hall-plan/${hall._id}`);
                                  }}
                                  onMouseEnter={(e) => {
                                    const shape = e.target;
                                    shape.fill(
                                      hexToRGBA(
                                        getHoverColor(hall.color),
                                        HOVER_TRANSPARENCY
                                      )
                                    );
                                    shape.getLayer().batchDraw();
                                  }}
                                  onMouseLeave={(e) => {
                                    const shape = e.target;
                                    shape.fill(
                                      hexToRGBA(hall.color, TRANSPARENCY)
                                    );
                                    shape.getLayer().batchDraw();
                                  }}
                                />
                              </Group>
                            ))}
                          {newHalls
                            ?.filter((hall) => hall.shape.type === "Rectangle")
                            .map((hall, index) => (
                              <Rect
                                key={index}
                                x={hall.shape.shape.x}
                                y={hall.shape.shape.y}
                                width={hall.shape.shape.width}
                                height={hall.shape.shape.height}
                                fill={hexToRGBA(hall.color, TRANSPARENCY)}
                                onClick={() => {
                                  navigate(`/hall-plan/${hall._id}`);
                                }}
                                onMouseEnter={(e) => {
                                  const shape = e.target;
                                  shape.fill(
                                    hexToRGBA(
                                      getHoverColor(hall.color),
                                      HOVER_TRANSPARENCY
                                    )
                                  );
                                  shape.getLayer().batchDraw();
                                }}
                                onMouseLeave={(e) => {
                                  const shape = e.target;
                                  shape.fill(
                                    hexToRGBA(hall.color, TRANSPARENCY)
                                  );
                                  shape.getLayer().batchDraw();
                                }}
                              />
                            ))}
                        </Layer>
                      </Stage>
                    ) : (
                      <Box
                        sx={{
                          height: "100%",
                          display: "grid",
                          placeItems: "center",
                        }}
                      >
                        <Stack alignItems="center" spacing={1.5}>
                          <CircularProgress size={30} />
                          <Typography variant="body2" color="text.secondary">
                            Preparing your floor plan…
                          </Typography>
                        </Stack>
                      </Box>
                    )}
                  </Box>
                </Box>
              ) : (
                <Box
                  component="button"
                  type="button"
                  onClick={() => setShowImageCrop(true)}
                  sx={{
                    width: "100%",
                    minHeight: { xs: 340, sm: 480 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed",
                    borderColor: "primary.light",
                    borderRadius: 2.5,
                    p: 4,
                    cursor: "pointer",
                    color: "text.primary",
                    bgcolor: "rgba(2, 71, 95, 0.025)",
                    transition: "all 160ms ease",
                    "&:hover": {
                      bgcolor: "rgba(2, 71, 95, 0.06)",
                      borderColor: "primary.main",
                      transform: "translateY(-1px)",
                    },
                    "&:focus-visible": {
                      outline: "3px solid rgba(2, 71, 95, 0.2)",
                      outlineOffset: 3,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      display: "grid",
                      placeItems: "center",
                      borderRadius: "50%",
                      color: "primary.main",
                      bgcolor: "background.paper",
                      boxShadow: "0 8px 24px rgba(2, 71, 95, 0.12)",
                      mb: 2,
                    }}
                  >
                    <CloudUploadOutlinedIcon sx={{ fontSize: 32 }} />
                  </Box>
                  <Typography variant="h6" fontWeight={700}>
                    Upload a venue map
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.75, maxWidth: 420, textAlign: "center" }}
                  >
                    Add a clear floor-plan image, then draw and link your
                    exhibition halls.
                  </Typography>
                  <Chip
                    label="JPG, JPEG or PNG · Max 2 MB"
                    size="small"
                    variant="outlined"
                    sx={{ mt: 2.5, bgcolor: "background.paper" }}
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} lg={4} sx={{ display: "flex" }}>
          <Card
            variant="outlined"
            sx={{
              width: "100%",
              borderRadius: 3,
              borderColor: "divider",
              boxShadow: "0 10px 30px rgba(2, 71, 95, 0.06)",
            }}
          >
            <CardContent
              sx={{
                p: { xs: 2, sm: 3 },
                pb: "24px !important",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack
                direction="row"
                alignItems="flex-start"
                justifyContent="space-between"
                spacing={2}
                sx={{ mb: 2.5 }}
              >
                <Box>
                  <Typography variant="h6" fontWeight={700}>
                    Exhibition halls
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {hallCount === 0
                      ? "No halls have been added yet."
                      : `${hallCount} ${
                          hallCount === 1 ? "hall" : "halls"
                        } on this map`}
                  </Typography>
                </Box>
                <Chip
                  label={hallCount}
                  size="small"
                  color="primary"
                  sx={{ fontWeight: 700, minWidth: 34 }}
                />
              </Stack>

              <Button
                fullWidth
                color="primary"
                startIcon={<AddCircleOutlineIcon />}
                variant="contained"
                onClick={() => {
                  navigate("/fp-add-hall", { replace: true });
                }}
                sx={{
                  py: 1.1,
                  textTransform: "none",
                  borderRadius: 2,
                  boxShadow: "none",
                }}
              >
                Add new hall
              </Button>

              <Divider sx={{ my: 2.5 }} />

              <List
                disablePadding
                sx={{
                  flex: 1,
                  maxHeight: 490,
                  overflowY: "auto",
                  pr: hallCount > 5 ? 0.75 : 0,
                  "&::-webkit-scrollbar": { width: 6 },
                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: "grey.300",
                    borderRadius: 3,
                  },
                }}
              >
                {hallCount > 0 ? (
                  data.halls.map((hall, index) => (
                    <Card
                      key={hall._id || index}
                      variant="outlined"
                      sx={{
                        p: 1.5,
                        mb: 1.25,
                        borderRadius: 2,
                        borderColor: "divider",
                        transition:
                          "border-color 150ms ease, box-shadow 150ms ease",
                        "&:hover": {
                          borderColor: "primary.light",
                          boxShadow: "0 6px 16px rgba(2, 71, 95, 0.07)",
                        },
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                          sx={{
                            width: 38,
                            height: 38,
                            flexShrink: 0,
                            display: "grid",
                            placeItems: "center",
                            borderRadius: 1.5,
                            color: hall.color || "primary.main",
                            bgcolor: hall.color
                              ? hexToRGBA(hall.color, 0.14)
                              : "rgba(2, 71, 95, 0.08)",
                          }}
                        >
                          <MeetingRoomOutlinedIcon fontSize="small" />
                        </Box>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography
                            variant="body1"
                            fontWeight={600}
                            noWrap
                            title={hall.name}
                          >
                            {hall.name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Hall {index + 1}
                          </Typography>
                        </Box>
                        <Tooltip title={`Manage ${hall.name}`}>
                          <IconButton
                            onClick={(e) => hanldeHallMenuClick(e, hall)}
                            size="small"
                            aria-label={`Manage ${hall.name}`}
                            sx={{
                              color: "text.secondary",
                              "&:hover": {
                                color: "primary.main",
                                bgcolor: "rgba(2, 71, 95, 0.08)",
                              },
                            }}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Card>
                  ))
                ) : (
                  <Stack
                    alignItems="center"
                    justifyContent="center"
                    spacing={1.5}
                    sx={{ minHeight: 260, px: 3, textAlign: "center" }}
                  >
                    <Box
                      sx={{
                        width: 58,
                        height: 58,
                        display: "grid",
                        placeItems: "center",
                        borderRadius: "50%",
                        bgcolor: "grey.100",
                        color: "text.secondary",
                      }}
                    >
                      <MeetingRoomOutlinedIcon sx={{ fontSize: 28 }} />
                    </Box>
                    <Box>
                      <Typography fontWeight={600}>
                        Start with a hall
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5 }}
                      >
                        Add a hall to make areas of the venue map interactive.
                      </Typography>
                    </Box>
                  </Stack>
                )}
              </List>

              {hallCount > 0 && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <LoadingButton
                    fullWidth
                    startIcon={<DeleteOutlineIcon />}
                    size="small"
                    color="error"
                    loading={hallDeleting}
                    onClick={() => {
                      setConfirmAllDelete(true);
                    }}
                    sx={{ textTransform: "none", borderRadius: 2 }}
                  >
                    Delete all halls
                  </LoadingButton>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default GeneralFloorPlan;
